
  // PayWay Trusted Frame in callback mode: payway.js -> createCreditCardFrame
  // -> getToken -> data.singleUseTokenId. Research note, section 2.
  //
  // Remount case: the payer/staff pages remove this container on a
  // decline and re-render it on "Try again", so `mounted()` runs again
  // on the same page. payway.js must never be appended twice — that
  // would at best waste a round trip and at worst redefine
  // `window.payway` mid-flight — so start() is only ever reached one of
  // three ways: (1) the SDK global already exists -> call start()
  // immediately, no script append; (2) a <script> with this exact src
  // is already in <head> (a prior mount's, maybe still loading) -> ride
  // ITS load/error events instead of adding a second tag, or call
  // start() directly if it already finished (its data-loaded marker);
  // (3) neither exists yet -> append the one script and tag it
  // data-loaded on load, so a LATER remount takes branch (2)'s
  // already-loaded path.
  export default {
    mounted() {
      const { publishableKey, scriptUrl } = this.el.dataset;
      const mountId = `${this.el.id}-mount`;
      const fail = (message) => this.pushEvent("card_frame_error", {message});
      const start = () => {
        window.payway.createCreditCardFrame({
          publishableApiKey: publishableKey,
          tokenMode: "callback",
          layout: "wide",
          style: "font-family: inherit;"
        }, (err, frame) => {
          if (err) { fail(err.message || "The card form could not be loaded"); return; }
          frame.el = document.getElementById(mountId);
          this.frame = frame;
        });
      };
      if (window.payway) {
        start();
      } else {
        const existing = document.head.querySelector(`script[src="${scriptUrl}"]`);
        if (existing) {
          if (existing.dataset.loaded) {
            start();
          } else {
            existing.addEventListener("load", start);
            existing.addEventListener("error", () => fail("The card form could not be loaded"));
          }
        } else {
          const script = document.createElement("script");
          script.src = scriptUrl;
          script.onload = () => { script.dataset.loaded = "true"; start(); };
          // Remove the failed tag rather than leaving it in <head> with
          // no data-loaded marker — otherwise a LATER remount's
          // `existing` branch finds it, attaches listeners to an
          // element whose load/error events already fired, and never
          // calls start() or fail() again (stuck on "still loading").
          script.onerror = () => { script.remove(); fail("The card form could not be loaded"); };
          document.head.appendChild(script);
        }
      }
      this.el.querySelector(`#${this.el.id}-pay`).addEventListener("click", () => {
        if (!this.frame) { fail("The card form is still loading"); return; }
        this.frame.getToken((err, data) => {
          if (err) { fail(err.message || "Check the card details"); return; }
          this.pushEvent("card_tokenised", {token: data.singleUseTokenId});
        });
      });
    },
    destroyed() { if (this.frame && this.frame.destroy) this.frame.destroy(); }
  }
